<template>
  <button
    class="flex items-start justify-between w-full h-40 pt-3 text-left outline-none gap-x-2"
    :disabled="cantConnect"
    @click.prevent="connectIntegration"
  >
    <NuxtImg
      :src="logo"
      :alt="`Integration ${title}`"
      class="flex-none w-10 h-10 rounded-full"
    />
    <div class="flex flex-col gap-y-3 shrink">
      <div class="flex items-center gap-x-2 flex-nowrap">
        <h4 class="text-xl font-semibold">
          {{ title }}
        </h4>
        <span
          v-if="hasError"
          class="px-2.5 py-1 rounded bg-red-100 text-red-400 text-xs"
        >Error</span>
      </div>
      <p class="text-xs font-light text-gray-400">
        {{ description }}
      </p>
    </div>
    <button
      class="flex-none text-xs"
      :class="{
        'brand-button flex gap-x-1.5 text-slate-50': integrationStatus === 'Connected',
        'brand-button': integrationStatus === 'Connect',
        'px-4 py-2 rounded bg-slate-100 border border-slate-200 text-slate-400 disabled:cursor-not-allowed': integrationStatus === 'Coming Soon',
      }"
      :disabled="cantConnect"
    >
      <span>{{ integrationStatus }}</span>
      <span v-if="integrationStatus === 'Connected'">
        <CheckSmall custom-style="h-4 w-4" />
      </span>
    </button>
  </button>
</template>

<script>
export default {
  name: 'DatapointIntegration',

  props: {
    logo: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    typeId: {
      type: [String, Number],
      required: true,
    },
    option: {
      type: [String, Number],
      required: true,
    },
    typeName: {
      type: String,
      default: '',
    },
    questions: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['navigateToIntegration'],

  data() {
    return {
      hasError: false,
    }
  },
  computed: {
    integrations() {
      return this.$store.integrations.listOptions
    },
    upcomingIntegrations() {
      return this.integrations.filter(integration => integration !== 'Rest API')
    },
    cantConnect() {
      return this.upcomingIntegrations.includes(this.title)
    },
    integrationStatus() {
      const integrations = JSON.parse(localStorage.getItem('integrations'))
      const status = integrations[slugify(this.title)] && integrations[slugify(this.title)].includes(`${this.typeId}-${this.option}`) ? 'Connected' : 'Connect'
      return this.cantConnect ? 'Coming Soon' : status
    },
  },

  mounted() {
    const cid = localStorage.getItem('cid')
    if (slugify(this.title) === 'rest-api') {
      this.$axios.get(`/v1/integrations/${cid}/api-integrations/get/`).then(({ data }) => {
        const typeDatapoints = data.filter(({ name, question, type }) => name.includes('Datapoint') && this.typeName === type && this.questions.includes(question.toString()))
        if (this.apiIntegrationHasErrors(typeDatapoints)) {
          this.hasError = true
        }
      })
    }
  },

  methods: {
    connectIntegration() {
      if (this.integrationStatus === 'Connect') {
        const integrations = JSON.parse(localStorage.getItem('integrations'))
        integrations[slugify(this.title)].push(`${this.typeId}-${this.option}`)
        localStorage.setItem('integrations', JSON.stringify(integrations))
      }
      this.$emit('navigateToIntegration', { page: this.title })
    },
    apiIntegrationHasErrors(datapoints) {
      const datapointsWithSortedResponses = datapoints
        .filter(datapoint => datapoint.api_integration_response_objects.length)
        .map((datapoint) => {
          datapoint.api_integration_response_objects.sort((first, next) => next.id - first.id)
          return datapoint
        })
      return datapointsWithSortedResponses.some(datapoint => datapoint.api_integration_response_objects[0].status_code !== '200')
    },
  },
}
</script>
